import { motion } from "framer-motion";

export default function AIAnalysis({ ai }) {
  if (!ai) return null;
  return (
    <section
      data-testid="ai-analysis"
      className="panel p-6 md:p-7 fade-up delay-1"
    >
      <div className="flex items-center justify-between mb-5">
        <div>
          <div className="overline">Root-cause analysis</div>
          <h3 className="font-display text-xl text-slate-900 mt-1">
            How this vulnerability works
          </h3>
        </div>
        <span className="text-[10px] font-mono text-violet-700 border border-violet-200 bg-violet-50 px-2 py-1 rounded-md">
          AI · GENERATED
        </span>
      </div>

      {ai.summary && (
        <p
          data-testid="ai-summary"
          className="text-slate-900 text-base leading-relaxed mb-5"
        >
          {ai.summary}
        </p>
      )}

      {ai.root_cause && (
        <div className="mb-6">
          <div className="overline mb-2">Root cause</div>
          <p
            data-testid="ai-root-cause"
            className="text-slate-700 text-sm leading-relaxed"
          >
            {ai.root_cause}
          </p>
        </div>
      )}

      {Array.isArray(ai.attack_flow) && ai.attack_flow.length > 0 && (
        <div className="mb-6">
          <div className="overline mb-3">Attack flow</div>
          <ol className="space-y-2" data-testid="ai-attack-flow">
            {ai.attack_flow.map((s, i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, x: -6 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.05, duration: 0.3 }}
                className="flex gap-3 items-start"
              >
                <span className="font-mono text-xs text-violet-700 mt-0.5 shrink-0 w-6">
                  0{s.step ?? i + 1}
                </span>
                <div>
                  <div className="text-sm text-slate-900">{s.action}</div>
                  {s.detail && (
                    <div className="text-xs text-slate-500 mt-0.5">
                      {s.detail}
                    </div>
                  )}
                </div>
              </motion.li>
            ))}
          </ol>
        </div>
      )}

      {ai.diff_analysis && (
        <div className="border-t border-slate-100 pt-4">
          <div className="overline mb-2">Patch analysis</div>
          <p className="text-slate-700 text-sm leading-relaxed">
            {ai.diff_analysis}
          </p>
        </div>
      )}

      {Array.isArray(ai.key_takeaways) && ai.key_takeaways.length > 0 && (
        <div className="border-t border-slate-100 pt-4 mt-4">
          <div className="overline mb-2">Key takeaways</div>
          <ul className="space-y-1.5">
            {ai.key_takeaways.map((t, i) => (
              <li
                key={i}
                className="text-sm text-slate-700 flex gap-2 items-start"
              >
                <span className="text-violet-700 font-mono">•</span>
                <span>{t}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
